import { call, put, select, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { Breadcrumb } from 'types/page-model';
import { selectBreadcrumbs } from 'features/page-model/ducks/get-model';
import {
  CompareCategory,
  getVariantsModel,
  isProductSet,
  selectCompareCategory,
  selectProductBrand,
  selectProductPriceCategory,
} from 'features/product-info';
import {
  selectProductAvailability,
  selectProductAvailableQuantity,
  selectProductBelong,
  selectProductDiscount,
  selectProductId,
  selectProductName,
  selectProductPrice,
  selectProductPricePrevious,
  selectReviewsTotalCount,
  selectReviewsTotalScore,
  selectVariantsRatingAvg,
  selectVariantsReviewsTotal,
} from './selectors';
import { GaProductBelong } from './types';
import { VariantsModel } from '../../variants';
/**
 * Cобытие должно срабатывать при загрузке страницы.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaDetail = createAction('GA:detail')<{
  elementType: 'page';
  elementBlock: 'productDetail' | 'komplektyDetail'; // блок, в котором расположен элемент
  // elementName: string; // название файла основного изображения товара (из Media Repository)
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productBelong: GaProductBelong; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productAvailability: string;
  productsQuantityAvailable: string;
  productPrevPrice: string | null;
  productDiscount: number | null;
  division: string; // отдел, к которому относится товар
  subdivision: string; // подотдел, к которому относится товар
  productTag?: string | null; // название шильда (бейджа) на товаре
  brand?: string | null;
  category?: string;
  komplektyId: string | null; // идентификатор комплекта (Передавать, если товар-комплект). Для обычных товаров не передавать этот параметр
  is_variable: boolean;
  variant_selected: string | null;
  avgRating: string; // средний рейтинг товара
  reviews: string; // количество отзывов о товаре
  variantsReviewsTotal: string; // суммарное количество отзывов о всех вариантах товара
  variantsRatingAvg: string; // средний рейтинг среди всех вариантов товара
}>();

let counter = 0;
export function* putGaDetail() {
  const breadcrumbs = (yield call(selectBreadcrumbs)) as Breadcrumb[];
  const variantsModelContainer: VariantsModel | null = yield select(getVariantsModel);
  const { variantsModel, activePoint } = variantsModelContainer ?? {};
  const isVariable = Boolean(variantsModel && variantsModel.length > 0);
  const variantSelected = isVariable && activePoint?.displayedName ? activePoint.displayedName : null;
  const brand = (yield call(selectProductBrand)) as string;
  const compareCategory = (yield call(selectCompareCategory)) as CompareCategory;
  const division = (breadcrumbs && breadcrumbs[2]?.label) || '';
  const subdivision = (breadcrumbs && breadcrumbs[3]?.label) || '';
  const isSet: boolean = yield select(isProductSet);
  const elementBlock = isSet ? 'komplektyDetail' : 'productDetail';
  const komplektyId: string | null = isSet ? yield call(selectProductId) : null;

  yield put(
    gaDetail({
      elementType: 'page',
      elementBlock,
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productAvailability: yield call(selectProductAvailability),
      productsQuantityAvailable: yield call(selectProductAvailableQuantity),
      productPrevPrice: yield call(selectProductPricePrevious),
      productDiscount: yield call(selectProductDiscount),
      productTag: yield call(selectProductPriceCategory),
      division,
      subdivision,
      brand,
      category: compareCategory?.name || '',
      komplektyId,
      is_variable: isVariable,
      variant_selected: variantSelected,
      avgRating: yield call(selectReviewsTotalScore),
      reviews: yield call(selectReviewsTotalCount),
      variantsReviewsTotal: yield call(selectVariantsReviewsTotal),
      variantsRatingAvg: yield call(selectVariantsRatingAvg),
    }),
  );
}

export function* putGaDetailProduct() {
  const isSet: boolean = yield select(isProductSet);

  if (isSet) return;

  const hasInfoLoad = (yield !!call(selectProductId)) as boolean;

  if (hasInfoLoad || counter >= 10) {
    counter = 0;
    yield putGaDetail();
  } else {
    counter++;
    setTimeout(putGaDetail, 1000);
  }
}

export function* putGaDetailSet() {
  const isSet: boolean = yield select(isProductSet);

  if (!isSet) return;

  yield putGaDetail();
}

export function* runDetailDetector() {
  yield takeEvery('supply/FETCH_GOODS_SUPPLY_DATA/success', putGaDetailProduct);
}
